import cloneDeep from 'lodash/cloneDeep'
import uniq from 'lodash/uniq'
// 把后台schema变成动态表单schema

// 有一个映射关系
export const needExchangeSchemaNameMap = {
  amount: 'CxNumberInput'
}

export class SchemaModel {
  constructor(options) {
    this.label = options.label
    try {
      if (typeof options.attrs === 'string') {
        const { options: option, isShow, required, ...attrs } = JSON.parse(options.attrs)

        this.options = option || []
        this.defaultOptions = cloneDeep(this.options) // 深拷贝一份
        this.vif = isShow
        this._vif = isShow
        this.required = required
        this.attrs = attrs
        this.rules = []

        this.setType(options.type, attrs)
      }
    } catch (error) {
      console.error('json parse attrs error', error)
    }

    this._vifOptions = [] // vif 函数

    this._linkageFields = [] // optionsLinkageFields
    this._linkage = []
  }

  setType(type, attrs) {
    if (!type) {
      throw new Error('传递过来的没有组件type')
    }
    this._type = type // 存储原始的type
    if (Object.keys(needExchangeSchemaNameMap).includes(this._type)) {
      this.type = 'form-custom'
      this.is = needExchangeSchemaNameMap[type] || type
    } else {
      this.type = type
    }
    // input类型的特殊处理
    if (this.attrs.unit) {
      this.label += `(${this.attrs.unit})`
    }
    if (this._type === 'input') {
      // input分为  单行输入框、多行输入框和数字输入框，需要特殊处理一下
      if (this.attrs.maxLength) {
        this.attrs.maxlength = this.attrs?.maxLength
        this.attrs['show-word-limit'] = true
        delete this.attrs.maxLength
      }

      if (this.attrs.type === 'number') {
        this.attrs.type = ''
        this.type = 'form-custom'
        this.is = 'CxNumberInput' // 强制使用我们的组件，因为我们的组件有最大值最小值约束
        if (this?.attrs?.range?.length === 2) {
          const [min, max] = this.attrs.range
          this.attrs.min = +min
          this.attrs.max = +max
        }
      }
    }
    // amount类型的特殊处理
    if (this._type === 'amount') {
      this.attrs.precision = 2 // 金额保持两位小数
      this.tip = this.attrs.tips || ''
      this.attrs.unit = '元'
      // 强制拼接上金额单位
      if (this.attrs.unit) {
        this.label += '(元)'
      }
      if (this?.attrs?.range?.length === 2) {
        const [min, max] = this.attrs.range
        this.attrs.min = +min
        this.attrs.max = +max
      }
    }
    // upload组件特殊处理
    if (this._type === 'upload') {
      this.type = 'CxUpload'
      this.tip = this.attrs.exampleTitle || ''
    }
  }
}

// 生成schema
export const transform2Schema = ({ componentList = {}, controlList = [] } = {}) => {
  const schema = {}
  if (Object.keys(componentList)?.length === 0) {
    return schema
  }
  // 设置默认的模板
  for (const component of componentList || []) {
    const { key, ...rest } = component
    schema[key] = new SchemaModel(rest)
  }

  // 设置vif、options等内容
  for (const { conditionList, effectList, relation } of controlList) {
    const conditionMap = {
      conditionStrings: [],
      conditionFields: []
    }
    // 目前type一直为INCLUDE
    for (const { key, type, value } of conditionList) {
      conditionMap.conditionStrings.push(setCondition({ key, value }))
      conditionMap.conditionFields.push(key) // optionsLinkageFields 会用到这个字段
    }

    const conditionStr = '___' + conditionMap.conditionStrings.join(` ${relation === 'AND' ? '&&' : '||'} `)

    for (const { key, effectType, value } of effectList) {
      if (effectType === 'isShow') {
        schema[key]._vifOptions.push(conditionStr.replace('___', value === 'true' ? '' : '!'))
      }

      if (effectType === 'setOption') {
        // 如果有设置选项，就vif为true,否则就用它本来的展示逻辑
        const tag = schema[key]._vif ? '' : '!'
        schema[key]._vifOptions.push(conditionStr.replace('___', JSON.parse(value).length ? '' : tag))
        schema[key]._linkage.push({
          conditons: conditionStr.replace('___', ''),
          effects: JSON.parse(value).map(v => +v) // value一直是字符串，如果传数组的话也是被JSON.stringify,强转数字
        })
        schema[key]._linkageFields = schema[key]._linkageFields.concat(conditionMap.conditionFields)
      }
    }
  }

  for (const key of Object.keys(schema)) {
    if (schema[key]._vifOptions.length) {
      schema[key].vif = toVifFunction(schema[key]._vifOptions)
    }
    if (schema[key]._linkage.length) {
      schema[key].options = toOptionFunction(schema[key]._linkage, schema[key].defaultOptions)
      schema[key].optionsLinkageFields = uniq(schema[key]._linkageFields)
    }
  }

  console.log('【客诉小结单】最终的schema生成', schema)

  return schema
}

// condition.value一定要是个数组
const setCondition = condition => {
  return `${JSON.stringify(condition.value)}.includes(formData[${JSON.stringify(condition.key)}])`
}

const toVifFunction = vifList => {
  const vifStr = `return ${vifList.join(` || `)}`
  // eslint-disable-next-line no-new-func
  return new Function('formData', vifStr)
}

const toOptionFunction = (optionsList, defaultOptions) => {
  const optionsStr =
    optionsList
      .map(({ conditons, effects }) => {
        return `if (${conditons}) { return ${JSON.stringify(
          defaultOptions.filter(value => effects.includes(+value.value))
        )}};`
      })
      .join('') + `return ${JSON.stringify(defaultOptions)}`
  console.log('----toOptionFunction---', optionsStr)
  // eslint-disable-next-line no-new-func
  return new Function('formData', optionsStr)
}

export const matchControls = (controlList, formData) => {
  const result = {}
  for (const { conditionList, effectList, relation } of controlList) {
    let flag = false
    if (relation === 'AND') {
      // 全命中或者只命中一个
      flag = conditionList.every(({ key, type, value }) => value.includes(formData[key])) // 如果conditionList和formData的值都命中了，则看effectList中的recommendFirstBusinessType和sopComplaintBusinessType值
    } else {
      flag = conditionList.some(({ key, type, value }) => value.includes(formData[key]))
    }

    if (flag) {
      for (const { key, effectType, value } of effectList) {
        if (key === 'recommendFirstBusinessType' && effectType === 'assign') {
          result.recommendFirstBusinessType = value
        }
        if (key === 'sopComplaintBusinessType' && effectType === 'assign') {
          result.sopComplaintBusinessType = value
        }
      }
    }
  }
  return result
}

// 获取级联选择所有配置项，做回填判断使用
export function getCascaderOptionsMap(data = []) {
  function getItemValueList(options = [], value = [], prevList = []) {
    if (!Array.isArray(options)) return value
    options.forEach(item => {
      const prevListCache = [...prevList, item.value]
      if (!Array.isArray(item.children)) {
        value.push(prevListCache.join('-'))
      } else {
        getItemValueList(item.children, value, prevListCache)
      }
    })
    return value
  }
  return getItemValueList(data)
}

// 提取表单展示项
export function getVisibleFormItemList(formSchema = {}, componentList = []) {
  const list = []
  for (const key in formSchema) {
    try {
      if (formSchema[key]._vif) {
        const com = componentList?.find?.(i => i.key === key)
        list.push({
          key: key,
          type: com?.type || formSchema[key]?._type
        })
      }
    } catch (e) {
      console.log(e)
    }
  }
  return list
}
